import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "./Setup.css";
import Seo from "../components/Seo";

import GettingStarted from "../components/setup/GettingStarted";
import NewSweepstakes from "../components/setup/NewSweepstakes";
import BonusSpendingThreshold from "../components/setup/BonusSpendingThreshold";
import SchedulePromotion from "../components/setup/SchedulePromotion";
import EntryWidgets from "../components/setup/EntryWidgets";
import AutoProductEntries from "../components/setup/AutoProductEntries";
import AccountExtensionGuide from "../components/setup/AccountExtensionGuide";
import Referrals from "../components/setup/Referrals";
import Affiliates from "../components/setup/Affiliates";
import EmailService from "../components/setup/EmailService";
import EmailSignupRewards from "../components/setup/EmailSignupRewards";
import OrderMultipliers from "../components/setup/OrderMultipliers";
import Membership from "../components/setup/Membership";
import DiscountCodes from "../components/setup/DiscountCodes";
import AMOE from "../components/setup/AMOE";
import CustomFeatures from "../components/setup/CustomFeatures";

const TABS = [
  { id: "getting-started", label: "Getting Started", Comp: GettingStarted },
  { id: "new-sweepstakes", label: "New Sweepstakes", Comp: NewSweepstakes },
  { id: "bonus-spending-threshold", label: "Bonus Spending Threshold", Comp: BonusSpendingThreshold },
  { id: "schedule-promotion", label: "Schedule Promotion", Comp: SchedulePromotion },
  { id: "auto-product-entries", label: "Display entry widget", description: "For ALL products", Comp: AutoProductEntries },
  { id: "entry-widgets", label: "Widgets", Comp: EntryWidgets },
  {
    id: "account-ext",
    label: "Account Extension",
    Comp: AccountExtensionGuide,
  },
  { id: "referrals", label: "Referrals", Comp: Referrals },
  { id: "affiliates", label: "Affiliates", Comp: Affiliates },
  { id: "email-service", label: "Email Service", Comp: EmailService },
  {
    id: "email-signup-rewards",
    label: "Email Signup Entries",
    Comp: EmailSignupRewards,
  },
  { id: "order-multipliers", label: "Order Multipliers", Comp: OrderMultipliers },
  { id: "membership", label: "Membership", Comp: Membership },
  { id: "discount-codes", label: "Discount Codes", Comp: DiscountCodes },
  { id: "amoe", label: "Alternative Method of Entry (AMOE)", Comp: AMOE },
  { id: "custom-features", label: "Custom Features", Comp: CustomFeatures },
];

export default function Setup() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialId = searchParams.get("tab") ?? TABS[0].id;
  const initialIdx = Math.max(
    TABS.findIndex((t) => t.id === initialId),
    0
  );

  const [selected, setSelected] = useState(initialIdx);
  const Active = TABS[selected].Comp;

  // Update URL on tab change
  const handleSelect = (idx) => {
    setSelected(idx);
    setSearchParams({ tab: TABS[idx].id });
  };

  // Sync state if user navigates with browser buttons
  useEffect(() => {
    const id = searchParams.get("tab");
    const idx = TABS.findIndex((t) => t.id === id);
    if (idx !== -1 && idx !== selected) setSelected(idx);
  }, [searchParams, selected]);

  return (
    <main className="setup">
      <Seo
        title="Setup Guides | Clean Sweeps"
        description="Setup guides for Clean Sweeps: entry rules, widgets, account extension, referrals, affiliates, and email signup entries."
        path="/setup"
        image="/og/setup.png"
        imageAlt="Clean Sweeps setup guides"
      />
      <h1 className="setup__title">Setup Guides</h1>

      <nav className="setup__tabs">
        {TABS.map((tab, i) => (
          <button
            key={tab.id}
            className={`setup__tab ${selected === i ? "is-active" : ""}`}
            onClick={() => handleSelect(i)}
          >
            {tab.label}
            {tab.description && <span className="setup__tab-description">{tab.description}</span>}
          </button>
        ))}
      </nav>

      <section className="setup__card">
        <Active />
      </section>
    </main>
  );
}
